import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
  coverImagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  const [options, setOptions] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/questions/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries(data?.data);
        setOptions(data?.data?.questionAnswers?.options);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function handleChange(e) {
    let { name, value } = e.target;
    if (typeof value !== 'object') {
      if (value.includes('{') && value.includes('}')) {
        value = JSON.parse(value);
      }
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
    options,
    setOptions,
  };
}

function QuestionBooleanAnswer(props) {
  const classes = useStyles();
  const options = [
    {
      options: [
        {
          option: 'Verdadero',
          image: '',
        },
        {
          option: 'Falso',
          image: '',
        },
      ],
      correctIndex: 0,
    },
    {
      options: [
        {
          option: 'Verdadero',
          image: '',
        },
        {
          option: 'Falso',
          image: '',
        },
      ],
      correctIndex: 1,
    },
  ];
  return (
    <FormControl variant="outlined" className={classes.input}>
      <InputLabel id="demo-simple-select-label">
        Seléccione la respuesta correcta
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        name="questionAnswers"
        value={JSON.stringify(props.answer)}
        onChange={props.handleChange}
        native
      >
        <option value={JSON.stringify(options[0])}>Verdadero</option>
        <option value={JSON.stringify(options[1])}>Falso</option>
      </Select>
    </FormControl>
  );
}

function useOpts(options) {
  const [opts, setOpts] = useState(options);
  return {
    opts,
    setOpts,
  };
}

const uploadImages = async (files) => {
  try {
    let formData = new FormData();
    for (const file of files) {
      formData.append('image', file);
    }
    let response = await fetch(
      'https://api.edicionesmilenio.com/api/questions/images',
      {
        method: 'POST',
        body: formData,
      }
    );
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
};

function QuestionMultipleChoiceAnswer(props) {
  const classes = useStyles();
  const { options, setOptions } = useForm();
  const [option, setOption] = useState('');
  const [image, setImage] = React.useState('');
  const [coverImage, setCoverImage] = React.useState('');
  const filePickerRef = React.useRef(null);
  const coverImagePreviewRef = React.useRef(null);

  function addOption() {
    let question = { option, image: image };
    setOptions([...options, { ...question }]);
    setOption('');
    setImage('');
  }

  const handleDelete = (rowsDeleted) => {
    let ops = [];
    rowsDeleted?.data?.forEach((row, index) => {
      ops = [...ops, options[row?.dataIndex]];
    });
    setOptions(options.filter((option) => !ops.includes(option)));
  };

  useEffect(() => {
    props.handleChange({
      target: {
        name: 'questionAnswers',
        value: JSON.stringify({
          options,
          correctIndex: props?.entries?.questionAnswers?.correctIndex,
        }),
      },
    });
  }, [options]);

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <TextField
          style={{ height: '30px', marginTop: '10px', marginBottom: '20px' }}
          id="outlined-basic"
          label="Escriba una opcion de respuesta"
          variant="outlined"
          value={option}
          onChange={(e) => setOption(e.target.value)}
          name="question"
        />
      </div>
      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
        onClick={() => {
          setCoverImage('');
          filePickerRef.current.click();
        }}
        className={classes.coverImagePicker}
      >
        {coverImage && (
          <img
            style={{ width: '400px', height: 'auto', marginRight: '20px' }}
            ref={coverImagePreviewRef}
            src={
              typeof coverImage === 'string'
                ? 'https://api.edicionesmilenio.com' + coverImage
                : URL.createObjectURL(coverImage)
            }
            alt="preview"
          />
        )}
        <input
          ref={filePickerRef}
          style={{ display: 'none' }}
          type="file"
          name="coverImage"
          onChange={async (e) => {
            let files = e.target.files;
            setCoverImage(files[0]);
            let response = await uploadImages(files);
            if (response.success) {
              setImage(response?.data?.uri);
              const reader = new FileReader();
              reader.onload = (e) => {
                coverImagePreviewRef.current.src = e.target.result;
              };
              reader.readAsDataURL(files[0]);
            }
          }}
          accept="image/*"
        />
        {image && <p>{coverImage?.name}</p>}
        {!image && (
          <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
            Seleccione une imagen para la respuesta
          </p>
        )}
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Button
          variant="contained"
          onClick={addOption}
          className={classes.input}
          style={{ background: '#2490AF', color: 'white' }}
        >
          Agregar opción
        </Button>
      </div>
      <div
        style={{
          width: '100%',
          marginTop: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MUIDataTable
          data={options}
          columns={[
            {
              name: 'option',
              label: 'Opciones de respuesta',
            },
            {
              name: 'image',
              label: 'Imagen',
              options: {
                customBodyRenderLite: (dataIndex, rowIndex) => {
                  if (
                    !options[dataIndex]?.image ||
                    options[dataIndex]?.image === ''
                  ) {
                    return <strong>N/A</strong>;
                  }
                  return (
                    <img
                      style={{
                        width: '100px',
                        height: 'auto',
                        marginRight: '20px',
                      }}
                      src={
                        'https://api.edicionesmilenio.com' +
                        options[dataIndex]?.image
                      }
                      alt="preview"
                    />
                  );
                },
              },
            },
          ]}
          options={{
            search: false,
            download: false,
            print: false,
            viewColumns: false,
            filter: false,
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="answers">Seléccione la respuesta correcta</InputLabel>
          <Select
            id="answers"
            name="questionAnswers"
            value={JSON.stringify(props.answer) || ''}
            onChange={props.handleChange}
            native
            label="Seléccione la respuesta correcta"
          >
            <option value="" disabled>
              <em>Seleccione la respuesta correcta</em>
            </option>
            {options.map((option, index) => (
              <option
                value={JSON.stringify({
                  options: options,
                  correctIndex: index,
                })}
              >
                {option.option || 'imagen ' + (index + 1)}
              </option>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

export function UpdateQuestion(props) {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const { series } = useSeries();
  const { grades } = useGrades();
  const navigate = useNavigate();
  const filePickerRef = React.useRef(null);

  const activityTypes = [
    'Prueba diagnóstica',
    'Evaluación de periodo',
    'Taller evaluativo 1',
    'Taller evaluativo 2',
    'Taller evaluativo 3',
    'Taller evaluativo 4',
    'Taller evaluativo 5',
    'Taller de práctica 1',
    'Taller de práctica 2',
    'Taller de práctica 3',
    'Taller de práctica 4',
    'Taller de práctica 5',
  ];

  const handleUpdate = async () => {
    console.log(entries);
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/questions/${entries?._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...entries }),
        }
      );
      if (response.status === 200) {
        navigate('/admin/questions');
      } else {
        let json = await response.json();
        console.error(json.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        <div
          style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          className={classes.coverImagePicker}
          onClick={() => {
            filePickerRef.current.click();
          }}
        >
          {entries?.image ? (
            <img
              style={{
                width: '400px',
                height: 'auto',
                marginRight: '20px',
              }}
              src={
                typeof entries?.image === 'string'
                  ? 'https://api.edicionesmilenio.com' + entries?.image
                  : URL.createObjectURL(entries?.image)
              }
              alt="preview"
            />
          ) : (
            <p>
              Esta pregunta no tiene imagen, para seleccionar una haz click aquí
            </p>
          )}
          <input
            ref={filePickerRef}
            style={{ display: 'none' }}
            type="file"
            name="coverImage"
            onChange={async (e) => {
              let files = e.target.files;
              let response = await uploadImages(files);
              if (response.success) {
                handleChange({
                  target: {
                    name: 'image',
                    value: response?.data?.uri,
                  },
                });
                // setImage(response.data.uri);
                // const reader = new FileReader();
                // reader.onload = (e) => {
                //   coverImagePreviewRef.current.src = e.target.result;
                // };
                // reader.readAsDataURL(files[0]);
              }
            }}
            accept="image/*"
          />
        </div>

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Enunciado de la pregunta"
          variant="outlined"
          value={entries?.question || ''}
          onChange={handleChange}
          name="question"
          multiline
          rows={4}
        />

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-serie">Serie del libro</InputLabel>

          <Select
            onChange={handleChange}
            value={entries?.serie?._id || ''}
            name="serie"
            id="select-serie"
            label="Serie del libro"
            native
          >
            <option value="" disabled>
              <em>Seleccione una serie</em>
            </option>
            {series.map((serie) => (
              <option value={serie?._id}>{serie?.name}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Grado</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.grade?._id || ''}
            name="grade"
            id="select-grade"
            native
            label="Grado"
          >
            <option value="" disabled>
              <em>Seleccione un grado</em>
            </option>
            {grades.map((grade) => (
              <option value={grade?._id}>{grade?.name}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-period">Periodo</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.period}
            name="period"
            id="select-period"
            native
            label="Periodo"
          >
            <option value="" disabled>
              <em>Seleccione un periodo</em>
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-questionType">Tipo de pregunta</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.questionType}
            name="questionType"
            id="select-questionType"
            native
            label="Tipo de pregunta"
          >
            <option value="" disabled>
              <em>Seleccione un tipo de pregunta</em>
            </option>
            <option value="evaluation">Evaluación</option>
            <option value="workshop">Taller</option>
            <option value="open">Abierta</option>
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-activityType">Tipo de actividad</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.activityType}
            name="activityType"
            id="select-activityType"
            native
            label="Tipo de actividad"
          >
            <option value="" disabled>
              <em>Seleccione un tipo de actividad</em>
            </option>
            {activityTypes.map((activityType) => (
              <option value={activityType}>{activityType}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">¿Es pregunta contextual?</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.isContextual}
            name="isContextual"
            id="select-grade"
            native
            label="¿Es pregunta contextual?"
          >
            <option value="" disabled>
              <em>Seleccione una opción</em>
            </option>
            <option value={'true'}>Si</option>
            <option value={'false'}>No</option>
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Tipo de respuesta</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.answerType || ''}
            name="answerType"
            id="select-grade"
            native
            label="Tipo de respuesta"
          >
            <option value="" disabled>
              <em>Seleccione un tipo de respuesta</em>
            </option>
            {entries?.answerType === 'boolean' && (
              <option value="boolean">Falso o Verdadero</option>
            )}
            {entries?.answerType === 'multiple' && (
              <option value="multiple">Seleccion multiple</option>
            )}
            {entries?.answerType === 'open' && (
              <option value="open">Abierta</option>
            )}
          </Select>
        </FormControl>

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Retro alimentación respuesta correcta"
          variant="outlined"
          value={entries?.questionCorrectAnswerMessage || ''}
          onChange={handleChange}
          name="questionCorrectAnswerMessage"
        />

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Retro alimentación respuesta incorrecta"
          variant="outlined"
          value={entries?.questionIncorrectAnswerMessage || ''}
          onChange={handleChange}
          name="questionIncorrectAnswerMessage"
        />

        <div
          style={{
            display: 'flex',
            paddingTop: '20px',
            paddingBottom: '20px',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          {entries?.answerType === 'boolean' && (
            <QuestionBooleanAnswer
              handleChange={handleChange}
              answer={entries?.questionAnswers}
            />
          )}
          {entries?.answerType === 'multiple' && (
            <QuestionMultipleChoiceAnswer
              entries={entries}
              handleChange={handleChange}
              answer={entries?.questionAnswers}
            />
          )}
        </div>

        <Button
          onClick={handleUpdate}
          variant="contained"
          style={{ background: '#2490AF', color: 'white' }}
        >
          Actualizar pregunta
        </Button>
      </div>
    </div>
  );
}
